import styled from 'styled-components';

export const PointsColumn = styled.div``;

export const Subtitle = styled.div`
  font-size: 1rem;
  margin: 0;
  text-align: end;
`;
